/* Show catalog prices with the customer's applied discount code already deducted.

   Shopify evaluates codes on the cart, never on catalog prices, so this recomputes them in the
   theme. It only runs when the applied code provably covers everything — target_selection "all"
   with a percentage value — because a code scoped to certain products cannot be evaluated from
   the storefront, and guessing would show a price that changes at checkout. */
(() => {
  const MARK = 'codePriced';

  let percent = null;

  const money = (cents) =>
    `${Math.round(cents / 100)
      .toLocaleString('sv-SE')
      .replace(/ /g, ' ')} kr`;

  const rewrite = (el) => {
    if (MARK in el.dataset) return;
    // cart line prices are already discounted by Shopify; touching them would double-count
    if (el.closest('.cart-drawer, .thb-cart-form, .mcd-columns')) return;

    const cents = parseInt(el.dataset.price, 10);
    const ins = el.querySelector('ins .amount');
    if (!Number.isFinite(cents) || cents <= 0 || !ins) return;

    const before = ins.textContent.trim();
    ins.textContent = money(Math.round(cents * (1 - percent / 100)));
    // the theme already paints .discounted with --color-price-discounted
    ins.classList.add('discounted');

    let del = el.querySelector('del .amount');
    if (!del) {
      const wrap = document.createElement('del');
      del = document.createElement('span');
      del.className = 'amount';
      wrap.appendChild(del);
      el.insertBefore(wrap, el.querySelector('ins'));
    }
    del.textContent = before;

    el.dataset[MARK] = '';
  };

  const run = () => document.querySelectorAll('.price[data-price]').forEach(rewrite);

  fetch(`${window.theme?.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } })
    .then((r) => r.json())
    .then((cart) => {
      const found = (cart.cart_level_discount_applications || [])
        .map((entry) => entry.discount_application || entry)
        .find(
          (d) =>
            d.type === 'discount_code' &&
            d.target_selection === 'all' &&
            d.value_type === 'percentage'
        );
      if (!found) return;

      percent = parseFloat(found.value);
      if (!(percent > 0)) return;

      run();
      // facets, quick-add and the drawer swap markup in, so newly inserted prices need it too
      let queued = false;
      new MutationObserver(() => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          run();
        });
      }).observe(document.body, { childList: true, subtree: true });
    })
    .catch(() => {});
})();
